// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/bed_configuration.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_feature_hotel_hotel_types } from "./hotel_types_pb";

/**
 * Describes the file proto/model/feature/hotel/bed_configuration.proto.
 */
export const file_proto_model_feature_hotel_bed_configuration = /*@__PURE__*/
  fileDesc("CjFwcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL2JlZF9jb25maWd1cmF0aW9uLnByb3RvEgZjYXJtZW4iYQoQQmVkQ29uZmlndXJhdGlvbhIhCghiZWRfdHlwZRgBIAEoDjIPLmNhcm1lbi5CZWRUeXBlEhAKCHF1YW50aXR5GAIgASgFEhgKEHNpemVfZGVzY3JpcHRpb24YAyABKAlCNlo0Z2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWwvZmVhdHVyZS9ob3RlbGIGcHJvdG8z", [file_proto_model_feature_hotel_hotel_types]);

/**
 * Describes the message carmen.BedConfiguration.
 * Use `create(BedConfigurationSchema)` to create a new message.
 */
export const BedConfigurationSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_bed_configuration, 0);

